interface Modal {
  element: HTMLElement
  /**
   * null means the modal is not mounted
   */
  shouldLock: boolean
  disableScrollLock?: boolean
}

const modals: Modal[] = []

const handleScrollLock = () => {
  for (const modal of modals) {
    if (modal.disableScrollLock) {
      continue
    }
    if (modal.shouldLock) {
      document.documentElement.style.overflow = 'hidden'
      break
    }

    document.documentElement.style.overflow = ''
  }
}

export const modalScrollLockHelper = () => {
  const modalUpdate = (modal: HTMLElement, shouldLock: boolean, disableScrollLock?: boolean) => {
    const index = modals.findIndex(m => m.element === modal)
    if (index === -1) {
      modals.push({ element: modal, shouldLock, disableScrollLock })
      handleScrollLock()
    }
    else if (modals[index]) {
      modals[index].shouldLock = shouldLock
      modals[index].disableScrollLock = disableScrollLock
      handleScrollLock()
    }
  }

  const modalUnmount = (modal: HTMLElement) => {
    const index = modals.findIndex(m => m.element === modal)
    if (index !== -1 && modals[index]) {
      /**
       * Before unmounting the modal, we need to set shouldLock to false.
       * This is to ensure that the scroll lock is unlocked when the last modal is unmounted.
       */
      modals[index].shouldLock = false
      handleScrollLock()
      modals.splice(index, 1)
    }
  }

  return {
    modalUpdate,
    modalUnmount,
  }
}
